import { render } from "./UseLogs.vue?vue&type=template&id=f07aa572&scoped=true"
import script from "./UseLogs.vue?vue&type=script&lang=js"
export * from "./UseLogs.vue?vue&type=script&lang=js"

import "./UseLogs.vue?vue&type=style&index=0&id=f07aa572&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f07aa572"]])

export default __exports__